import { render, staticRenderFns } from "./TeachersDropdown.vue?vue&type=template&id=541650c7&"
import script from "./TeachersDropdown.vue?vue&type=script&lang=js&"
export * from "./TeachersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports